













import { Component, Mixins } from "vue-property-decorator";
import { CalculatableObjectDrawerBase } from "./base";
import { default as NamedRectangleCoordinatableObjectDrawer } from "./NamedRectangleCoordinatableObjectDrawer.vue";

@Component({
  components: {
    NamedRectangleCoordinatableObjectDrawer,
  },
})
export default class JoinTextObjectDrawer extends Mixins(CalculatableObjectDrawerBase) {}
